"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGradingCalculators = void 0;
const DefaultGradeKeys_1 = __importDefault(require("./DefaultGradeKeys"));
const DefaultGradingCalculatorKey_1 = __importDefault(require("./DefaultGradingCalculatorKey"));
const GradingRuleType_1 = __importDefault(require("./GradingRuleType"));
exports.DefaultGradingCalculators = [
    {
        key: DefaultGradingCalculatorKey_1.default,
        title: 'Default Audit',
        rules: [
            {
                type: GradingRuleType_1.default.SCOREGTE,
                scoreGte: 80,
                scoreLt: undefined,
                grade: DefaultGradeKeys_1.default.GREEN,
            },
            {
                type: GradingRuleType_1.default.SCOREBETWEEN,
                scoreGte: 60,
                scoreLt: 80,
                grade: DefaultGradeKeys_1.default.AMBER,
            },
        ],
        failoverGrade: DefaultGradeKeys_1.default.RED,
        immediateFailGrade: DefaultGradeKeys_1.default.RED,
    },
];
exports.default = exports.DefaultGradingCalculators;
